import styled from "styled-components"


export const Container = styled.div`
  position: fixed;
  height: 80px;
  top:80px;
  width: 240px;
  z-index: 951;
  background-color: rgb(41, 52, 125);
  color:white;
  padding-top:12px;
  > div {
    margin:12px;
  }

  [role="listbox"] {
    max-height:218px;
  }
`

